export default {
  documents: [],
  documentsSigned: [],
  documentsPending: [],
  documentsRejected: [],
  documentsInvited: [],
  documentsInvitedSigned: [],
  documentsInvitedPending: [],
  documentsArchived: []
}
